import React from 'react';
import ReactDOM from 'react-dom/client';
import Portfolio from './Portfolio';
import reportWebVitals from './reportWebVitals';

const main = ReactDOM.createRoot(document.getElementById('main'));
main.render(
  <React.StrictMode>
    <Portfolio />
  </React.StrictMode>
);

reportWebVitals();
